import { rememberPdfRotation } from "./pdfViewPreferences.mjs";
import { fitPdfPage } from "./pdfPageFit.mjs";

/** Small adapter used by the shared toolbar; editor code stays lazy. */
export function createPdfApplication(component, pdf) {
    const viewer = component._viewer;
    const application = {
        pdfDocument: pdf, pdfViewer: viewer, eventBus: component._pdfEvents,
        get thumbnailsVisible(){return component.thumbnails;},
        pdfCursorTools: { switchTool: (tool) => { component.panEnabled = tool === 1; } },
        zoomIn: () => viewer.increaseScale(), zoomOut: () => viewer.decreaseScale(),
        rotatePages: (angle) => {
            const page = viewer.currentPageNumber;
            viewer.pagesRotation = (viewer.pagesRotation + angle + 360) % 360;
            rememberPdfRotation(component.context?.revision_id || pdf.fingerprints[0], viewer.pagesRotation, page);
            fitPdfPage(viewer, "page-fit", page);
        },
        goToPage: (position) => component.goToPage(component.pageOrder?.[position - 1] || position),
        pagePosition: (number) => component.pageOrder?.length ? component.pageOrder.indexOf(number) + 1 : number,
        setPageOrder: (order, { editable = false, busy = false } = {}) => {
            component.pageOrder = order.slice();
            component.reorderEnabled = editable; component.reorderBusy = busy;
            if (editable && order.length > 1) component.thumbnails = true;
            component._pdfEvents?.dispatch("pageorderchanged", {});
        },
        setMarkupPreview: (annotations) => {
            if (component._application && component._application !== application) return;
            component.markupPreview = annotations.slice();
        },
        toggleThumbnails: (visible) => { component.thumbnails = typeof visible === "boolean" ? visible : !component.thumbnails; },
        findBar: { toggle: () => {
            component.searchOpen = !component.searchOpen;
            if (component.searchOpen) component.$nextTick(() => component.$refs.search?.focus());
        } },
        download: async () => {
            const blob = new Blob([await pdf.getData()], { type: "application/pdf" });
            const url = URL.createObjectURL(blob), anchor = window.document.createElement("a");
            anchor.href = url;
            anchor.download = component.filename?.toLowerCase().endsWith(".pdf") ? component.filename : `${component.filename || "documento"}.pdf`;
            anchor.click();
            window.setTimeout(() => URL.revokeObjectURL(url), 1000);
        },
    };
    return application;
}
